<template>
      <crud-delete :open="open"
                 :loading="loading"
                 :title="title"
                 :errorMessage="errorMessage"
                 @delete="remove"
                 @close="$emit('close')"
    >

        <v-card-text>
          <product-show-data :item="item" />
        </v-card-text>

        <v-card-text>
            <v-row justify="center">
                <span class="title">{{areYouSure}}</span>
            </v-row>
        </v-card-text>

    </crud-delete>
</template>

<script>
    //Provider
    import ProductProvider from "../../../../providers/ProductProvider";

    //Show Data
    import ProductShowData from "../ProductShow/ProductShowData";

    //Common
    import {CrudDelete, ClientError} from '@dracul/common-frontend'

    export default {
        name: "ProductDelete",

        components: {ProductShowData, CrudDelete},

        props: {
          open: {type: Boolean, default: true},
          item: {type: Object, required: true}
        },

        data() {
            return {
                modal: false,
                title: 'delivery.product.deleting',
                areYouSure: this.$t('common.areYouSureDeleteRecord'),
                errorMessage: '',
                loading: false,
            }
        },
        methods: {
            remove() {
                this.loading = true
                ProductProvider.deleteProduct(this.item.id).then(result => {
                            if (result.data.deleteProduct.success) {
                                this.$emit('itemDeleted',result.data.deleteProduct)
                                this.$emit('close')
                            }else{
                                this.errorMessage = 'Error on Delete'
                            }
                        }
                    ).catch(error =>{
                        let clientError = new ClientError(error)
                        this.errorMessage = clientError.showMessage
                }).finally(() => this.loading = false)
            },
        },
    }
</script>


